module.exports = __webpack_public_path__ + "img/Orange-button-logo-flat-rgb.d6fd79dc.png";